import React, {Component} from 'react';
import backIcon from './back.png';
import unBackIcon from './unback.png';
import {toolWidth} from "../../twoLinesEditorToolsSpace";
import {EDITOR_TOOL_BTN_COLOR} from "../../../../../constants";

class BackTool extends Component {

    state = {
        src : unBackIcon
    };

    /**
     * 监听内容变化
     */
    listenContentChange(){
        let res = this.props.editor.queryCommandState('undo');
        if(res === -1){
            this.setState({src : unBackIcon})
        }else{
            this.setState({src : backIcon})
        }
    }

    render() {
        let res = this.props.editor.queryCommandState('undo');
        return (
            <span style={{cursor:"pointer"}} onClick={()=>{
                this.props.editor.execCommand( 'undo' );
            }}>
                <img className={"editor-back-tool-btn"} width={toolWidth} src={this.state.src} />
                <style>{`
                .editor-back-tool-btn{
                    border: 1px solid #f2f6fc
                }
                .editor-back-tool-btn:hover{
                    border: 1px solid ${EDITOR_TOOL_BTN_COLOR.hover}
                }
                .editor-back-tool-btn:active{
                    border: 1px solid ${EDITOR_TOOL_BTN_COLOR.press}
                }
            `}</style>
            </span>
        );
    }
}

export default BackTool;